import { render, staticRenderFns } from "./VasionResizableLayout.vue?vue&type=template&id=433bb086&scoped=true&"
import script from "./VasionResizableLayout.vue?vue&type=script&lang=js&"
export * from "./VasionResizableLayout.vue?vue&type=script&lang=js&"
import style0 from "./VasionResizableLayout.vue?vue&type=style&index=0&id=433bb086&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433bb086",
  null
  
)

export default component.exports